// Define initial state
const initialState = {
    lang: localStorage.getItem('language') || 'en',
  };
  
  // Define action types
  const SET_LANGUAGE = 'SET_LANGUAGE';
  
  // Define reducer function
  const languageReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_LANGUAGE:
        return {
          ...state,
          lang: action.payload.lang,
        };
      default:
        return state;
    }
  };


// Action creators
const setLanguage = (lang) => ({
  type: SET_LANGUAGE,
  payload: { lang }
});

export { setLanguage };
export default languageReducer;
  